module.exports = __webpack_public_path__ + "../static/img/career.9f0cd457.jpg";